import { useEffect, useRef } from "react"

import { Button } from "@/atoms"
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver"
import { ArrowDownOutlined } from "@/icons"
import { ANCHOR_ID } from "@/organisms/KaiChat/const"

import styles from "./ScrollBottomButton.module.scss"

import type { ScrollBottomButtonProps } from "./ScrollBottomButton.types"

export const ScrollBottomButton = (props: ScrollBottomButtonProps) => {
  const { parent } = props
  const buttonId = "scroll-to-bottom-button-kai-chat"
  const timer = useRef<NodeJS.Timeout | null>(null)

  useIntersectionObserver(
    `#${ANCHOR_ID}`,
    (entries) => {
      entries.forEach((entry) => {
        document
          .getElementById(buttonId)
          ?.classList.toggle(styles.containerVisible, !entry.isIntersecting)
      })
    },
    { threshold: 0, root: parent || null }
  )

  useEffect(() => {
    if (!parent) return

    const event = "scroll"
    const fn = () => {
      if (timer.current) clearTimeout(timer.current)

      document
        .getElementById(buttonId)
        ?.classList.toggle(styles.scrollHide, true)

      timer.current = setTimeout(() => {
        document
          .getElementById(buttonId)
          ?.classList.toggle(styles.scrollHide, false)
      }, 100)
    }

    parent.addEventListener(event, fn)

    return () => {
      if (timer.current) clearTimeout(timer.current)

      parent.removeEventListener(event, fn)
    }
  }, [parent])

  return (
    <div id={buttonId} className={styles.container}>
      <Button
        className={styles.button}
        shape="circle"
        icon={<ArrowDownOutlined />}
        onClick={() => {
          parent?.scrollTo({
            top: parent.scrollHeight,
            behavior: "smooth"
          })
        }}
      />
    </div>
  )
}
